import {
  Component,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  output,
  Output,
  viewChild,
} from "@angular/core";
import { JustupButton } from "../../models/justup-elems.model";
import { DisplayService } from "../../../features/home/services/display.service";
import { BigButtonComponent } from "../big-button/big-button.component";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-justup-page",
  standalone: true,
  imports: [BigButtonComponent, NgTemplateOutlet, NgClass, SharedModule],
  templateUrl: "./justup-page.component.html",
  styleUrls: ["./justup-page.component.scss"],
})
export class JustupPageComponent {
  displayService = inject(DisplayService);

  // @deprecated
  @Input() title: boolean;
  // @deprecated
  @Input() header: boolean;
  // @deprecated
  @Input() buttons: JustupButton[] = [];
  // @deprecated
  @Input() filter: boolean;
  // @deprecated
  @Output() filterAction = new EventEmitter();
  // @deprecated
  @Output() buttonAction = new EventEmitter<number>();

  scrollEndThreshold = input(100);
  scrollEnd = output();

  type = input<"small" | "large">("large");
  aside = input(false);
  staticAside = input(false);
  new = input(false);
  /**
   * Mode « data-grid » : le contenu remplit la hauteur et NE fait PAS scroller la
   * page (le scroll est délégué à un enfant, ex. `[vlScrollTable]`). Opt-in : par
   * défaut la page scrolle normalement. Active une chaîne flex pleine hauteur
   * (`.content-fill`) + coupe le scroll de la page. Voir
   * `plan/scroll-sticky-foundation.md`.
   */
  contentFill = input(false);
  mainContent = viewChild<ElementRef>("mainContent");
  private scrollListener = this.onScroll.bind(this);
  filterState: any;

  constructor() {
    effect(() => {
      if (this.mainContent()) {
        this.mainContent().nativeElement.addEventListener(
          "scroll",
          this.scrollListener,
        );
      }
    });
  }

  private onScroll(event: Event) {
    const el = event.target as HTMLElement;
    const threshold = this.scrollEndThreshold();
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
      this.scrollEnd.emit();
    }
  }
}
